module.exports = __webpack_public_path__ + "img/chart_pie.c6703c59.svg";